export const companyInfo = {
  name: 'Balazs Dach & Abbruch Service UG',
  slogan: 'Ihr zuverlässiger Partner für Dach- und Abbrucharbeiten',
  phone: '01578 1140651',
  email: 'info@dachdeckerbalazs-abbruch.de',
  address: 'Oesterheidestraße 14, 44892 Bochum',
  openingHours: {
    weekdays: 'Mo - Fr: 07:00 - 18:00 Uhr',
    saturday: 'Sa: 08:00 - 14:00 Uhr',
    sunday: 'So: Geschlossen'
  },
  instagram: '@balazs_dach_abbruch',
  instagramUrl: 'https://www.instagram.com/balazs_dach_abbruch'
};

export const services = [
  {
    id: 1,
    title: 'Dachdeckerarbeiten',
    description: 'Professionelle Neueindeckung, Dachreparatur und Dachsanierung mit hochwertigen Materialien.',
    icon: 'home',
    details: ['Neueindeckung', 'Dachreparatur', 'Dachsanierung', 'Flachdacharbeiten']
  },
  {
    id: 2,
    title: 'Zimmererarbeiten',
    description: 'Dachstuhlbau, Dachgeschossausbau und hochwertige Holzkonstruktionen.',
    icon: 'hammer',
    details: ['Dachstuhlbau', 'Dachgeschossausbau', 'Holzkonstruktionen', 'Carports']
  },
  {
    id: 3,
    title: 'Klempnerarbeiten',
    description: 'Fachgerechte Installation von Regenrinnen, Fallrohren und Blechverkleidungen.',
    icon: 'wrench',
    details: ['Dachrinnen', 'Fallrohre', 'Blechverkleidungen', 'Metallarbeiten']
  },
  {
    id: 4,
    title: 'Abbrucharbeiten',
    description: 'Professioneller Rückbau und Abbruch unter Einhaltung aller Sicherheitsvorschriften.',
    icon: 'construction',
    details: ['Gebäudeabbruch', 'Entkernung', 'Entsorgung', 'Gefahrstoffentsorgung']
  },
  {
    id: 5,
    title: 'Fassadenarbeiten',
    description: 'Fassadensanierung, Verkleidungen und Wärmedämmung für Ihr Gebäude.',
    icon: 'building',
    details: ['Fassadensanierung', 'Wärmedämmung', 'Verkleidungen', 'Anstricharbeiten']
  },
  {
    id: 6,
    title: 'Terrassenarbeiten',
    description: 'Planung und Bau von hochwertigen Terrassen und Außenanlagen.',
    icon: 'layout',
    details: ['Terrassenbau', 'Holzterrassen', 'Fliesenverlegung', 'Pflasterarbeiten']
  }
];

export const processSteps = [
  {
    step: 1,
    title: 'Erstberatung',
    description: 'Kostenlose Beratung und Besichtigung vor Ort. Wir analysieren Ihr Projekt und beraten Sie umfassend.'
  },
  {
    step: 2,
    title: 'Angebot',
    description: 'Sie erhalten ein detailliertes, transparentes Angebot mit allen Leistungen und Kosten.'
  },
  {
    step: 3,
    title: 'Planung',
    description: 'Gemeinsame Planung und Terminabstimmung für einen reibungslosen Ablauf Ihres Projekts.'
  },
  {
    step: 4,
    title: 'Ausführung',
    description: 'Professionelle Durchführung durch unser erfahrenes Team mit modernster Technik.'
  },
  {
    step: 5,
    title: 'Abnahme',
    description: 'Gemeinsame Abnahme und Übergabe. Ihre Zufriedenheit ist unser Ziel.'
  }
];

export const references = [
  {
    id: 1,
    title: 'Dachsanierung Einfamilienhaus',
    location: 'Bochum',
    description: 'Komplette Neueindeckung mit hochwertigen Tondachziegeln',
    image: 'https://images.unsplash.com/photo-1726589004565-bedfba94d3a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxyb29maW5nJTIwd29ya2Vyc3xlbnwwfHx8fDE3NjM0NTY2NDd8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 2,
    title: 'Abbrucharbeiten Industriegebäude',
    location: 'Dortmund',
    description: 'Professioneller Rückbau einer Lagerhalle',
    image: 'https://images.unsplash.com/photo-1665737847143-3080d0a12972?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxkZW1vbGl0aW9uJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc2MzQ1NjY1Mnww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 3,
    title: 'Dachgeschossausbau',
    location: 'Essen',
    description: 'Ausbau und Dämmung eines Dachgeschosses',
    image: 'https://images.unsplash.com/photo-1743610350670-db2f1cc54620?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxyb29maW5nJTIwd29ya2Vyc3xlbnwwfHx8fDE3NjM0NTY2NDd8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 4,
    title: 'Gewerbebau Neubau',
    location: 'Herne',
    description: 'Komplette Dachkonstruktion für Gewerbeimmobilie',
    image: 'https://images.pexels.com/photos/544966/pexels-photo-544966.jpeg'
  },
  {
    id: 5,
    title: 'Fassadensanierung',
    location: 'Bochum',
    description: 'Komplette Fassadenerneuerung mit Wärmedämmung',
    image: 'https://images.pexels.com/photos/35251424/pexels-photo-35251424.jpeg'
  },
  {
    id: 6,
    title: 'Abbruch Wohngebäude',
    location: 'Gelsenkirchen',
    description: 'Fachgerechter Abbruch mit Entsorgung',
    image: 'https://images.pexels.com/photos/11518765/pexels-photo-11518765.jpeg'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Michael Schmidt',
    role: 'Hausbesitzer',
    text: 'Hervorragende Arbeit! Das Team war pünktlich, professionell und das Ergebnis übertrifft unsere Erwartungen.',
    rating: 5
  },
  {
    id: 2,
    name: 'Sarah Weber',
    role: 'Bauherrin',
    text: 'Von der Beratung bis zur Fertigstellung alles perfekt. Sehr empfehlenswert!',
    rating: 5
  },
  {
    id: 3,
    name: 'Thomas Müller',
    role: 'Gewerbekunde',
    text: 'Zuverlässig, schnell und sauber. Genau so stelle ich mir professionelle Handwerksarbeit vor.',
    rating: 5
  }
];